import { storageLifecyclePlugin } from './plugin';

export default storageLifecyclePlugin;
